import React, { useState } from 'react';

import { Button, Heading, Flex } from 'theme-ui';
import { Link } from 'react-router-dom';

import Box from 'elements/Box';
import Sidenav from 'components/Sidenav';
import { useAuthContext } from 'contexts/AuthProvider';
import useAuth from 'hooks/useAuth';
import logo from 'assets/logo.svg';
import Spacer from 'elements/Spacer';
import pulse from 'assets/pulse.gif';
import MenuButton from './MenuButton';

const Header: React.FC = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const { authUser } = useAuthContext();
  const { logout } = useAuth();

  return (
    <React.Fragment>
      <Box
        display="flex"
        height={65}
        bg="muted"
        width={1}
        alignItems="center"
        justifyContent="space-between"
        px={3}
      >
        <MenuButton
          size={48}
          onClick={() => setMenuOpen(menuOpen => !menuOpen)}
        />
        <Link to="/" style={{ textDecoration: 'none', color: 'inherit' }}>
          <Box display="flex" alignItems="center">
            <img src={logo} height={40} width={40} alt="hubworld logo" />
            <Spacer size={2} horizontal />
            <Heading>Hubworld</Heading>
          </Box>
        </Link>
      </Box>
      <Sidenav onClick={() => setMenuOpen(false)} open={menuOpen}>
        <Flex
          sx={{
            flexDirection: 'column',
            alignItems: 'center',
            bg: 'darken',
            height: '100%',
            width: 256,
            flex: 1,
            px: 3,
            pt: 3,
            pb: 4
          }}
        >
          <img style={{ width: '100%' }} src={pulse} alt="animated logo" />
          <Box
            width={1 / 1}
            display="flex"
            alignItems="center"
            flexGrow={1}
            justifyContent="flex-end"
            flexDirection="column"
          >
            {authUser ? (
              <Button onClick={logout} sx={{ width: '100%' }}>
                Logout
              </Button>
            ) : (
              <Link to="/login" style={{ width: '100%' }}>
                <Button sx={{ width: '100%' }}>Login</Button>
              </Link>
            )}
          </Box>
        </Flex>
      </Sidenav>
    </React.Fragment>
  );
};

export default Header;
